
export const renderAddress = (address, maxLen = 20) => {
    if (address && address.length > maxLen) {
        const length = maxLen / 2;
        return `${address.slice(0, length)}...${address.slice(-length-1)}`;
    }

    return address;
};
